import { Dialog, DialogContent } from '@mui/material';
import { ModalHeader } from 'layouts/Generic/modal-header';
import React from 'react';
import fonts from 'styles/typography.module.css';
import { AddCredentialForm } from './AddCredentialForm';

interface Props {
  open: boolean;
  onClose: () => void;
}

export const AddCredential: React.FC<Props> = (props: Props) => {
  const { open, onClose } = props;
  return (
    <Dialog
      open={open}
      onClose={onClose}
      className={fonts.font}
      classes={{ paper: 'max-w-[800px]' }}
    >
      <ModalHeader onClose={onClose}>
        <p className="font-bold">Add a new terminal credential</p>
      </ModalHeader>
      <DialogContent dividers>
        <AddCredentialForm onClose={onClose} />
      </DialogContent>
    </Dialog>
  );
};
AddCredential.displayName = 'AddCredential';
